/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StartInputs */

const de__field_start = /** @type {(inputs: _Field_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann`)
};

/**

* @param {_Field_StartInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_start = /** @type {((inputs?: _Field_StartInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StartInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_start(inputs)
});